import { render, staticRenderFns } from "./ReindexButton.vue?vue&type=template&id=641fc95c"
import script from "./ReindexButton.vue?vue&type=script&lang=js"
export * from "./ReindexButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports